import { useNavigate } from "react-router-dom";
import { FlexCenterWrapper } from "../../../../../components/DefaultNoDataWrapper";
import { useQueryParams } from "../../../../../hooks/use-query-param";
import { useSnackbar } from "../../../../../hooks/useSnackbar";
import { setCallData } from "../../../../../redux/feature/join-room/JoinRoomSlice";
import { store } from "../../../../../redux/store";
import { ValidateDob } from "../validateDob";
import { useValidateDob } from "../dob-validation/useValidateDob";

const VerifyAndJoinTeleHealth = () => {
  const showSnackbar = useSnackbar();
  const patientId = useQueryParams("patientId");
  const appointmentId = useQueryParams("appointmentId");
  const room = useQueryParams("room");
  const providerName = useQueryParams("providerName");
  const patientName = useQueryParams("patientName");
  const startTime = useQueryParams("startTime");

  const { birthDate, setBirthDate, isAuthenticate, onVerify } = useValidateDob(
    patientId,
    showSnackbar
  );

  const navigate = useNavigate();

  function joinInstantAppointment() {
    store.dispatch(
      setCallData({
        room: room,
        patientId: patientId,
        appointmentId: appointmentId,
        patientName: patientName ?? "",
        providerName: providerName ?? "",
        startTime: startTime,
        role: 0,
      })
    );

    onVerify();
  }

  const patientIdParam = patientId ? `&patientid=${patientId}` : "";
  const appointmentIdParam = appointmentId
    ? `&appointmentid=${appointmentId}`
    : "";

  isAuthenticate &&
    navigate(
      `/public/video/subs?room=${room}&role=${0}&providerName=${
        providerName ?? ""
      }&patientName=${
        patientName ?? ""
      }&startTime=${startTime}${patientIdParam}${appointmentIdParam}`
    );

  return (
    <FlexCenterWrapper>
      <FlexCenterWrapper>
        <ValidateDob
          birthDate={birthDate}
          setBirthDate={setBirthDate}
          onVerify={() => joinInstantAppointment()}
          label="Please Select Birth Date To Verify"
        />
      </FlexCenterWrapper>
    </FlexCenterWrapper>
  );
};

export default VerifyAndJoinTeleHealth;
